// Copyright (c) Zammo Inc.
/**
 * Ephemeral "agent is working" status line shown above the answer bubble while a tool runs
 * (driven by the API connection's CallingMessage / the model's narration / a derived default).
 *
 * Look: a compact indigo-tinted pill with a pulsing "radar ping" dot — reads as a transient activity
 * indicator, distinct from a settled message bubble, and clears once the answer starts streaming.
 */
import React from 'react';

const ACCENT = '#6366f1'; // matches the indigo user bubble

const CSS = `
@keyframes zs-ping { 0% { transform:scale(1); opacity:.55 } 100% { transform:scale(2.6); opacity:0 } }

.zs-row { display:flex; align-items:center; align-self:flex-start; margin:4px 2px; max-width:80%; }
.zs-pill { display:inline-flex; align-items:center; gap:8px; padding:6px 13px; border-radius:999px;
  font-size:13px; line-height:1.2; white-space:nowrap; background:rgba(99,102,241,.09); color:#5550c4; }

.zs-ping { position:relative; width:8px; height:8px; flex-shrink:0; }
.zs-ping .core { position:absolute; inset:0; border-radius:50%; background:${ACCENT}; }
.zs-ping .ring { position:absolute; inset:0; border-radius:50%; background:${ACCENT}; animation:zs-ping 1.4s ease-out infinite; }
`;

export function StatusIndicator({ text }: { text: string }) {
  return (
    <div className="zs-row">
      <style>{CSS}</style>
      <span className="zs-pill">
        <span className="zs-ping">
          <span className="ring" />
          <span className="core" />
        </span>
        {text}
      </span>
    </div>
  );
}
